export default {
  socialLinks: {
    facebook: 'https://www.facebook.com/BaraemTV/',
    youtube: 'https://www.youtube.com/user/watchbaraem/',
    instagram: 'https://www.instagram.com/baraemtv/',
    twitter: 'https://twitter.com/BaraemTV',
  },
  downloadLinks: {
    appstore: 'https://baraem.tv/app/ios',
    googleplay: 'https://baraem.tv/app/android',
  },
  infoLinks: {
    terms: {
      en: 'https://www.bein.net/en/terms-conditions/',
      ar: 'https://www.bein.net/ar/%D8%A7%D9%84%D8%B4%D8%B1%D9%88%D8%B7-%D9%88%D8%A7%D9%84%D8%A3%D8%AD%D9%83%D8%A7%D9%85/',
    },
    policy: {
      en: 'https://www.bein.net/en/privacy-policy/',
      ar: 'https://www.bein.net/ar/%D8%B3%D9%8A%D8%A7%D8%B3%D8%A9-%D8%A7%D9%84%D8%AE%D8%B5%D9%88%D8%B5%D9%8A%D8%A9/',
    },
    frequencies: {
      en: 'https://www.bein.net/en/frequencies/',
      ar: 'https://www.bein.net/ar/%D8%A7%D9%84%D8%AA%D8%B1%D8%AF%D8%AF%D8%A7%D8%AA/',
    },
    help: {
      en: 'https://en-faq.bein.net/support/home',
      ar: 'https://ar-faq.bein.net/support/home',
    },
    feedback: {
      en: 'https://www.bein.net/en/contact-center/',
      ar: 'https://www.bein.net/ar/%D9%85%D8%B1%D9%83%D8%B2-%D8%A7%D9%84%D8%A7%D8%AA%D8%B5%D8%A7%D9%84/',
    },
  },
};
